import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogLocationsComponent } from '../../dialogs/dialog-location/dialog-locations.component';
import { LocationService } from '../../services/location.service';
var PopupMarkerComponent = /** @class */ (function () {
    function PopupMarkerComponent(authenticationService, locationService, fuseProgressBarService, matDialog) {
        this.authenticationService = authenticationService;
        this.locationService = locationService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.matDialog = matDialog;
        this.reload = function () { };
    }
    PopupMarkerComponent.prototype.openDialog = function (selectedLocation) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.locationService.getLocationById(selectedLocation.id)];
                    case 1:
                        location = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [4 /*yield*/, this.matDialog.open(DialogLocationsComponent, {
                                panelClass: ['dialog-locations'],
                                data: {
                                    location: location,
                                    isViewMode: !this.authenticationService.hasPermission('locations-edit')
                                }
                            }).afterClosed()
                                .toPromise()];
                    case 2:
                        result = _a.sent();
                        if (result && result.reload) {
                            this.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return PopupMarkerComponent;
}());
export { PopupMarkerComponent };
